import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getTrailUser = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/getTrialUsers${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createTrailUser = (data, token) =>
  axios.post(`${baseUrl}/createTrialUser`, data, {
    headers: {
      authorization: token,
    },
  });

export const deleteTrailUser = (id, token) =>
  axios.delete(`${baseUrl}/deleteTrialUser/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getTrailUserById = (id, token) =>
  axios.get(`${baseUrl}/getTrialUserById/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const updateTrailUser = (id, data, token) =>
  axios.patch(`${baseUrl}/TrailUser/${id}`, data, {
    headers: {
      authorization: token,
    },
  });
